<template>
    <div>
        <table :class="$style['review-oparetion-table']">
            <!-- <pt-form-list-item label="审核操作：" :required="true">
                <wt-radio :radios="awardRadios" v-model="form.status" data-vv-as="审核状态" name="name" v-validate="'required'">></wt-radio>
            </pt-form-list-item> -->
            <pt-form-list-item label="驳回原因：" :required="true">
                <wt-input type="textarea" :autosize="{ minRows: 2, maxRows: 6 }" v-model="form.rejectReason" v-validate="'required'" data-vv-as="驳回原因" name="REJECTED"></wt-input>
            </pt-form-list-item>
        </table>
          <div class="button-div">
        <el-button type="primary" @click="submit" :loading="submitLoading">确认</el-button>
        <el-button type="primary" plain @click="cancel">取消</el-button>
  </div>
    </div>
</template>
<script>
import { awardRadios } from './withdraw-manage'
import formMixins from 'mixins/form'
export default {
  mixins: [formMixins],
  props: {
    ids: {
      type: Array
    }
  },
  data () {
    return {
      form: {},
      awardRadios: awardRadios,
      submitLoading: false
    }
  },
  methods: {
    submit () {
      this.validate().then(_ => {
        this.auditOption()
      })
    },
    auditOption () {
      let data = {
        ids: this.ids,
        reason: this.form.rejectReason
      }
      this.submitLoading = true
      this.$store.dispatch('withdrawalReject', data).then(res => {
        this.submitLoading = false
        this.$message.success('驳回提现成功')
        this.$emit('closeDialog', true)
      }).catch(err => {
        this.submitLoading = false
        this.$message.error(err || '驳回提现失败')
        this.$emit('closeDialog', true)
      })
    },
    cancel () {
      this.$emit('closeDialog')
    }
  }

}
</script>
<style module lang="less">
.review-oparetion-table{
  padding: 0 20px
}
</style>
